var map = {
	"./admin-map-500.png": "sCru",
	"./admin-map-500.webp": "kHkl",
	"./admin-map-800.png": "2hYU",
	"./admin-map-800.webp": "eOHA",
	"./base-osm-500.png": "C508",
	"./base-osm-500.webp": "BB19",
	"./base-osm-800.png": "RE+Z",
	"./base-osm-800.webp": "t/cQ",
	"./city-map-500.png": "6v/p",
	"./city-map-500.webp": "TIxt",
	"./city-map-800.png": "SEFR",
	"./city-map-800.webp": "jx2M",
	"./directory-bdm-500.png": "vvXy",
	"./directory-bdm-500.webp": "Lgyc",
	"./directory-bdm-800.png": "6dX2",
	"./directory-bdm-800.webp": "4zTd",
	"./elevation-500.png": "d7x6",
	"./elevation-500.webp": "olSy",
	"./elevation-800.png": "Otyz",
	"./elevation-800.webp": "zhCd",
	"./geocoding-500.png": "q0rW",
	"./geocoding-500.webp": "pe0n",
	"./geocoding-800.png": "UDEF",
	"./geocoding-800.webp": "SKaa",
	"./image.config": "oJ6M",
	"./image.config.json": "oJ6M",
	"./land-use-500.png": "MS8P",
	"./land-use-500.webp": "UJG8",
	"./land-use-800.png": "ydQr",
	"./land-use-800.webp": "6ORY",
	"./land-use-plan-500.png": "mgnt",
	"./land-use-plan-500.webp": "0uz5",
	"./land-use-plan-800.png": "XC1j",
	"./land-use-plan-800.webp": "pink",
	"./marker-500.png": "ah1S",
	"./marker-500.webp": "T5ep",
	"./marker-800.png": "jmxR",
	"./marker-800.webp": "M8U0",
	"./measure-500.png": "67f7",
	"./measure-500.webp": "9fk1",
	"./measure-800.png": "MKcY",
	"./measure-800.webp": "ir7s",
	"./poi-500.png": "RFRp",
	"./poi-500.webp": "KE69",
	"./poi-800.png": "K6sr",
	"./poi-800.webp": "WoVh",
	"./population-500.png": "dHgE",
	"./population-500.webp": "jGvp",
	"./population-800.png": "LfMg",
	"./population-800.webp": "aNhw",
	"./protected-area-500.png": "8bk0",
	"./protected-area-500.webp": "qOqw",
	"./protected-area-800.png": "AbkT",
	"./protected-area-800.webp": "BjvO",
	"./re_landscape-500.png": "dukL",
	"./re_landscape-500.webp": "l5A4",
	"./re_landscape-800.png": "QFqp",
	"./re_landscape-800.webp": "X/D5",
	"./re_landuselv1-500.png": "iaCI",
	"./re_landuselv1-500.webp": "1HVv",
	"./re_landuselv1-800.png": "NrhX",
	"./re_landuselv1-800.webp": "fWa8",
	"./re_landuselv2-500.png": "yhi2",
	"./re_landuselv2-500.webp": "gnNE",
	"./re_landuselv2-800.png": "97QN",
	"./re_landuselv2-800.webp": "NzXr",
	"./re_landuselv3-500.png": "pL1n",
	"./re_landuselv3-500.webp": "aNy5",
	"./re_landuselv3-800.png": "80aW",
	"./re_landuselv3-800.webp": "6SBg",
	"./re_project-500.png": "eK/k",
	"./re_project-500.webp": "BUic",
	"./re_project-800.png": "XXqA",
	"./re_project-800.webp": "Je82",
	"./re_zooninglv1-500.png": "XvVW",
	"./re_zooninglv1-500.webp": "HZxx",
	"./re_zooninglv1-800.png": "Vkjg",
	"./re_zooninglv1-800.webp": "5ypf",
	"./re_zooninglv2-500.png": "Czml",
	"./re_zooninglv2-500.webp": "yhvv",
	"./re_zooninglv2-800.png": "tg0x",
	"./re_zooninglv2-800.webp": "Yw3q",
	"./reverse-500.png": "xCkO",
	"./reverse-500.webp": "PFt3",
	"./reverse-800.png": "ncYh",
	"./reverse-800.webp": "w5dH",
	"./road-map-500.png": "WSYd",
	"./road-map-500.webp": "xsxI",
	"./road-map-800.png": "Aabc",
	"./road-map-800.webp": "qs6R",
	"./routing-500.png": "GZho",
	"./routing-500.webp": "RAJv",
	"./routing-800.png": "Qi5Z",
	"./routing-800.webp": "pQ1C",
	"./simple-map-500.png": "FH/A",
	"./simple-map-500.webp": "xhrA",
	"./simple-map-800.png": "74Ou",
	"./simple-map-800.webp": "kvIu",
	"./soil-500.png": "NB9Q",
	"./soil-500.webp": "EXu4",
	"./soil-800.png": "egTp",
	"./soil-800.webp": "ZdXg",
	"./style-osm-500.png": "0rK7",
	"./style-osm-500.webp": "RDPt",
	"./style-osm-800.png": "kfaV",
	"./style-osm-800.webp": "cUz8",
	"./style-osm-night-500.png": "06Oi",
	"./style-osm-night-500.webp": "TTbX",
	"./style-osm-night-800.png": "C3tW",
	"./style-osm-night-800.webp": "fAdN",
	"./terrain-map-500.png": "dKRt",
	"./terrain-map-500.webp": "axGi",
	"./terrain-map-800.png": "abm7",
	"./terrain-map-800.webp": "ny0t",
	"./vietnam-map-500.png": "g/tf",
	"./vietnam-map-500.webp": "dOn6",
	"./vietnam-map-800.png": "u55+",
	"./vietnam-map-800.webp": "sLed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3Dyp";